// The mesh engines' parameters as plain data: the engines (registry.ts) and the Mesh export macro step (macros.ts)
// share them, and macros.ts (loaded by the editor server too) stays clear of the engines' code. Pure.
import type { Field } from '../edit/macros.ts';

export const TSDF_FIELDS: Field[] = [
  { k: 'num', key: 'voxel', label: 'voxels', dflt: 0.02, min: 0.004, max: 0.2, step: 0.005, unit: 'm' },
  { k: 'num', key: 'trunc', label: 'band', dflt: 0, min: 0, max: 0.3, step: 0.01, unit: 'm', blank: '3 voxels' },
  { k: 'num', key: 'maxDepth', label: 'depth to', dflt: 4, min: 0.3, max: 20, step: 0.5, unit: 'm' },
  { k: 'num', key: 'minW', label: 'seen at least', dflt: 0.5, min: 0, max: 64, step: 0.25, unit: 'views' },
  { k: 'num', key: 'minPart', label: 'dropping pieces under', dflt: 50, min: 0, int: true, unit: 'triangles' },
];

/** The depth's fields (the same as 'tsdf': the macro step shows them once for both), then the photos'. */
export const PHOTOVOX_FIELDS: Field[] = [
  ...TSDF_FIELDS,
  { k: 'num', key: 'passes', label: 'photo passes', dflt: 2, min: 1, max: 4, int: true },
  { k: 'num', key: 'shift', label: 'each photo shifted up to', dflt: 8, min: 0, max: 20, int: true, unit: 'px' },
  { k: 'bool', key: 'exposure', label: 'solving each photo\'s exposure', dflt: true },
  { k: 'num', key: 'agree', label: 'dropping surfaces whose photos disagree by over', dflt: 0, min: 0, max: 2, step: 0.05, blank: 'keep all' },
];

/** Engine id → its label and fields, for choosing one (keep in step with the engines registered: a test checks). */
export const ENGINE_FIELDS: Record<string, { label: string; fields: Field[] }> = {
  tsdf: { label: 'depth fusion (TSDF)', fields: TSDF_FIELDS },
  photovox: { label: 'depth fusion, colour solved across the photos', fields: PHOTOVOX_FIELDS },
};
